import Phaser from 'phaser';
import { Projectile, ProjectileConfig } from '@/entities/Projectile';
import { Actor } from '@/entities/Actor';

export class ProjectileManager {
  private scene: Phaser.Scene;
  private projectiles: Projectile[] = [];
  private enemyBases: Actor[] = [];

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
  }

  /** Set enemy bases so projectiles can deal collateral damage on impact */
  setEnemyBases(bases: Actor[]): void {
    this.enemyBases = bases;
  }

  spawn(config: Omit<ProjectileConfig, 'scene'>): Projectile {
    const projectile = new Projectile({ ...config, scene: this.scene, enemyBases: this.enemyBases });
    this.projectiles.push(projectile);
    return projectile;
  }

  update(delta: number): void {
    for (let i = this.projectiles.length - 1; i >= 0; i--) {
      const p = this.projectiles[i];
      if (!p.alive || p.isOutOfBounds()) {
        if (p.alive) p.destroy();
        this.projectiles.splice(i, 1);
        continue;
      }
      p.update(delta);
    }
  }

  clear(): void {
    for (const p of this.projectiles) {
      if (p.alive) p.destroy();
    }
    this.projectiles = [];
  }

  get count(): number {
    return this.projectiles.length;
  }
}
